import {UI} from "../../../../../../stem-core/ui/UIBase";

import {BasePanelPage} from "../../../../PanelPage";
import {SadFaceIcon} from "../../../../../../core/ui/SVGElements.jsx";
import {Messages} from "../../../../../Messages";
import {registerStyle} from "../../../../../../stem-core/ui/style/Theme";
import {PaymentFailedPanelStyle} from "../../payment-method/PaymentFailedPanel";
import {iFrameMerchantService} from "../../../../../services/IframeMerchantService";
import {TNR_ALIAS} from "../../../../../../blink-sdk/Constants";
import {dismissFlowSuccess} from "../../../../../widget/misc/WidgetUtils.js";
import {BlinkButton} from "../../../../../../core/ui/Button.jsx";


@registerStyle(PaymentFailedPanelStyle)
export class EditSubscriptionCancelSuccessPanel extends BasePanelPage {
    render() {
        const {styleSheet} = this;

        return [
            !iFrameMerchantService.isMerchant(TNR_ALIAS) && <SadFaceIcon
                className={styleSheet.icon}
                color={styleSheet.themeProps.TEXT_SECONDARY_COLOR}
            />,

            <div className={styleSheet.title}>
                {Messages.subscriptionCanceled}
            </div>,

            <BlinkButton className={styleSheet.actionButton} onClick={dismissFlowSuccess}>
                {Messages.ok}
            </BlinkButton>
        ];
    }
}
